/** Tetapan -> Perancangan: blok aliran kerja (Fasa 3 perancangan, pelan P3-3b D-161). Disebar ke settings-ms.ts. */
export default {
  title: 'Rujukan, nombor dan syarat',
  intro:
    'Digunakan oleh prosedur KM: agensi yang menerima edaran kes, cara surat keputusan dinomborkan, kod PBT, rancangan tempatan dan pustaka syarat.',
  agencies: 'Agensi rujukan',
  agenciesHint:
    'Jabatan majlis menjawab dalam gisify melalui kumpulan mereka; jawapan agensi luar dimasukkan oleh unit OSC.',
  agencyRow: 'Agensi {{index}}',
  agencyCode: 'Kod',
  agencyKind: 'Jenis',
  agencyNameIn: 'Nama ({{locale}})',
  agencyGroup: 'Kumpulan jabatan',
  noGroup: 'Belum ada kumpulan',
  addAgency: 'Tambah agensi',
  remove: 'Buang',
  numbering: 'Nombor keputusan',
  numberingHint:
    'Tulis {seq} di tempat nombor berjalan ({seq:4} mengisinya hingga empat digit), dan {yyyy} atau {yy} untuk tahun jika perlu.',
  preview: 'Nombor seterusnya akan berbentuk {{example}}.',
  schemes: {
    borang_c1: 'Borang C1 (kebenaran merancang)',
    kelulusan_bangunan: 'Kelulusan pelan bangunan',
  },
  pbtId: 'Kod majlis (PBT)',
  pbtIdHint:
    'Kod yang digunakan oleh eksport kebangsaan untuk majlis ini: huruf, digit, sempang dan garis bawah, hingga 32.',
  localPlanInForce: 'Rancangan tempatan sedang berkuat kuasa',
  localPlanInForceHint:
    'Jika tiada, kes KM memerlukan notis kepada jiran sebelum perakuan. Pendaftaran bermula daripada jawapan ini.',
  library: 'Pustaka syarat',
  libraryHint: 'Syarat yang boleh ditambah oleh pegawai kepada keputusan dalam satu langkah.',
  conditionRow: 'Syarat {{index}}',
  libraryCode: 'Kod',
  libraryPCode: 'Peringkat pematuhan',
  libraryText: 'Syarat',
  addCondition: 'Tambah syarat',
  choose: 'Pilih…',
  errors: {
    agencyCode:
      'Gunakan huruf kecil, digit, sempang atau garis bawah, bermula dengan huruf atau digit, paling banyak 40.',
    agencyRepeated: 'Agensi lain sudah menggunakan kod ini.',
    agencyLabel: 'Beri nama dalam sekurang-kurangnya satu bahasa, paling banyak 200 aksara setiap satu.',
    externalGroup: 'Agensi luar tidak mempunyai kumpulan jabatan.',
    agenciesMax: 'Paling banyak {{max}} agensi.',
    pbtId: 'Gunakan huruf, digit, sempang atau garis bawah, paling banyak 32.',
    libraryCode:
      'Mula dengan huruf atau digit, kemudian huruf, digit, titik, kurungan, sempang atau garis bawah, paling banyak 64.',
    libraryRepeated: 'Syarat lain sudah menggunakan kod ini.',
    libraryPCode: 'Nyatakan peringkat pematuhan.',
    libraryText: 'Tulis syarat itu, paling banyak 2000 aksara.',
    libraryTextCharacters:
      'Buang aksara kawalan tersembunyi (contohnya pemisah baris yang ditampal) daripada syarat itu.',
    libraryMax: 'Paling banyak {{max}} syarat.',
  },
  formatIssues: {
    empty: 'Tulis satu format.',
    too_long: 'Terlalu panjang: nombor mesti tidak melebihi 64 aksara.',
    unsafe: 'Buang aksara kawalan.',
    spaces: 'Buang ruang di awal atau di hujung.',
    no_sequence: 'Tambah {seq} atau {seq:N} untuk nombor berjalan.',
    two_sequences: 'Gunakan nombor berjalan sekali sahaja.',
    stray_brace: 'Kurungan kerinting hanya untuk {seq}, {seq:N}, {yyyy} dan {yy}.',
  },
} as const
